<template>
  <div class="gift-wechat-box" :class="{'ani': showWechatGiftAni}">
    <div class="mask"></div>
    <div class="wrap">
      <div class="head"></div>
      <div class="close" @click="close"></div>
      <div class="content">
        <div class="tit"><img src="//img.thebeastshop.com/app/4.0/icon/gift/txt-title.png?t=2" /></div>
        <div class="para">
          <p><i>1</i>为好友挑选礼物</p>
          <p><i>2</i>定制祝福并付款(<span style="color:#87522E;font-weight:600;">无需地址</span>)</p>
          <p><i>3</i>赠送微信好友</p>
          <p><i>4</i>好友收下你的心意</p>
          <p><i>5</i>野兽派将礼物送至你的好友</p>
        </div>
        <div class="tip">付款后24小时，若好友未领取将自动退款。</div>
        <div class="btn-gift" @click="doWechatGift">立即送礼</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showWechatGiftAni: false
    }
  },

  mounted () {
    setTimeout(() => {
      this.showWechatGiftAni = true
    }, 1);
  },

  methods: {
    doWechatGift () {
      this.showWechatGiftAni = false
      this.$emit('hide')
      this.$emit('buyWechatGift')
    },

    close () {
      this.$emit('hide')
    }
  }
}
</script>

<style lang="stylus">
</style>


// WEBPACK FOOTER //
// gift-box.vue?72ffbe60